import React from 'react';
interface SparklineProps {
  /** Response times in ms; 0 means the check failed. */
  values: number[];
  count?: number;
  label: string;
}
export function Sparkline({
  values,
  count = 24,
  label
}: SparklineProps) {
  const points = values.slice(-count);
  const max = Math.max(...points, 1);
  return <div className="flex h-6 items-end gap-[2px]" role="img" aria-label={label} data-id="element-427" data-mp="3ab8zdnr8okkm">
      {points.map((value, index) => {
      const failed = value === 0;
      const height = failed ? 100 : Math.max(12, value / max * 100);
      return <span key={index} className={`w-[3px] rounded-sm ${failed ? 'bg-critical' : 'bg-brand/45'}`} style={{
        height: `${height}%`
      }} data-id="element-428" data-mp="3obtgmfhia8c0" data-mpi={index} />;
    })}
    </div>;
}